export const TOKEN_TYPE_ANON = 'TOKEN_TYPE_ANON'
export const TOKEN_TYPE_FULL = 'TOKEN_TYPE_FULL'

export default {
  TOKEN_TYPE_ANON,
  TOKEN_TYPE_FULL
}
